<template>
    <div>
        <div class="flex h-screen-index overflow-y-auto">
            <ul class="menu bg-base-100 w-16 md:w-56 my-2 rounded-box !hidden md:!block" v-if="getIsSuperuser">
                <li>
                    <a :class="{ 'active': activeIndex === 1 }" @click="handleActive(1)">
                        <svg-icon name="sys-home" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">{{ $tt('system.menu.basic') }}</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 2 }" @click="handleActive(2)">
                        <svg-icon name="sys-backend" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">{{ $tt('system.menu.scraping') }}</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 3 }" @click="handleActive(3)">
                        <svg-icon name="sys-backend-task" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">{{ $tt('system.menu.tasks') }}</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 4 }" @click="handleActive(4)">
                        <svg-icon name="sys-xiaoai" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">{{ $tt('system.menu.xiaoai') }}</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 5 }" @click="handleActive(5)">
                        <svg-icon name="sys-webdav" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">{{ $tt('system.menu.webdav') }}</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 7 }" @click="handleActive(7)">
                        <svg-icon name="sys-openapi" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">{{ $tt('system.menu.openapi') }}</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 8 }" @click="handleActive(8)">
                        <svg-icon name="user" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">{{ $tt('system.menu.permission') }}</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 9 }" @click="handleActive(9)">
                        <svg-icon name="settings" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">{{ $tt('system.menu.personalization') }}</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 6 }" @click="handleActive(6)">
                        <svg-icon name="sys-info" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">{{ $tt('system.menu.info') }}</div>
                    </a>
                </li>
            </ul>
            <div class="flex-1 mx-2 my-2 rounded-2xl bg-base-100 md:p-8 overflow-y-auto">
                <component :is="currentComponent" :form-data="formData" @update-sys="HandleUpdateSys" @redirect-edit="redirctEditDetail" />
            </div>
        </div>
    </div>
</template>
<script>
import BasicSettings from './components/BasicSettings.vue'
import BackgroundScraping from './components/BackgroundScraping.vue'
import BackgroundTasks from './components/BackgroundTasks.vue'
import XiaoaiSpeaker from './components/XiaoaiSpeaker.vue'
import WebdavMusic from './components/WebdavMusic.vue'
import SystemInfo from './components/SystemInfo.vue'
import OpenApi from './components/OpenApi.vue'
import SvgIcon from '@/components/SvgIcon.vue'
import RolePermission from './components/RolePermission.vue'
import PersonalizationSettings from './components/PersonalizationSettings.vue'
import { mapState, mapGetters } from 'vuex'

export default {
    components: {
        BasicSettings,
        BackgroundScraping,
        BackgroundTasks,
        XiaoaiSpeaker,
        WebdavMusic,
        SystemInfo,
        OpenApi,
        SvgIcon,
        RolePermission,
        PersonalizationSettings
    },
    data() {
        return {
            activeIndex: 1,
            formData: {'access_token': ''}
        }
    },
    computed: {
        ...mapGetters(['getUsername', 'getIsSuperuser']),
        ...mapState({
            homeAction: state => state.common.homeAction,
            homeActionTimestamp: state => state.common.homeActionTimestamp
        }),
        currentComponent() {
            const componentMap = {
                1: 'BasicSettings',
                9: 'PersonalizationSettings',
                2: 'BackgroundScraping',
                3: 'BackgroundTasks',
                4: 'XiaoaiSpeaker',
                5: 'WebdavMusic',
                6: 'SystemInfo',
                7: 'OpenApi',
                8: 'RolePermission'
            }
            return componentMap[this.activeIndex] || 'BasicSettings'
        }
    },
    created() {
        this.fetchSysDict()
    },
    methods: {
        handleActive(index) {
            this.activeIndex = index
        },
        fetchSysDict() {
            this.$api.Task.getSysDict().then((res) => {
                if (res.result) {
                    this.formData = res.data
                    this.$store.commit('setSysDict', res.data)
                }
            })
        },
        HandleUpdateSys(key) {
            let value = this.formData[key]
            if (value.constructor === Boolean) {
                value = value ? '1' : '0'
            }
            if (key === 'silence_modify_list' || key === 'silence_source_list') {
                value = value.join(',')
            } else if (key === 'dir_list') {
                value = JSON.stringify(value)
            } else if (key === 'device_list' || key === 'silence_music_info' || key === 'artist_splitter_rules') {
                value = JSON.stringify(value)
            } else if (key === 'backend_task') {
                value = JSON.stringify(value)
            } else if (key === 'mi_play_in_pl') {
                window.localStorage.setItem('mi_play_in_pl', value)
            }
            this.$api.Task.UpdateSys({ 'key': key, value: value }).then((res) => {
                const nextSysDict = { ...this.$store.state.common.sysDict, [key]: this.formData[key] }
                if (key === 'opencode_server_username' || key === 'opencode_server_password') {
                    nextSysDict.opencode_authorization = this.buildOpenCodeAuthorization(nextSysDict)
                }
                this.$store.commit('setSysDict', nextSysDict)
                this.$myMsg.notify({
                    title: this.$tt('system.update.successTitle'),
                    type: 'success',
                    time: 1000,
                })
                // 如果修改的是网站标题，触发全局刷新事件
                if (key === 'site_title') {
                    this.$root.$emit('refresh-site-title')
                }
                // 如果修改的是版本标识显示，触发全局刷新事件
                if (key === 'show_role_badge') {
                    this.$root.$emit('refresh-role-badge')
                }
            })
        },
        buildOpenCodeAuthorization(sysDict) {
            const username = sysDict.opencode_server_username || ''
            const password = sysDict.opencode_server_password || ''
            if (!username && !password) {
                return ''
            }
            return 'Basic ' + window.btoa(unescape(encodeURIComponent(username + ':' + password)))
        },
        redirctEditDetail(path) {
            if (this.$route.name !== 'home') {
                this.$router.push({ name: 'home' })
            }
            this.$store.commit('setFullPath', path)
        },
        handleHomeAction(actionName) {
            const actionNameList = actionName.split(":")
            console.log(name, actionName.split(":"))
            this.activeIndex = actionNameList[1]
        }
    },
    watch: {
        homeActionTimestamp(newTimestamp, oldTimestamp) {
            // 当时间戳变化时，执行对应的操作
            console.log(newTimestamp, oldTimestamp, this.homeAction)
            if (newTimestamp > oldTimestamp && this.homeAction) {
                this.handleHomeAction(this.homeAction)
            }
        }
    },
}
</script>
